import type { StoreCatalog, StoreProduct } from 'app/javascript/data/storeCatalogs';

// Raw fetch wrappers for the public, read-only store. The endpoints are
// unauthenticated (the storefront is public), so they use plain fetch like the
// other public company endpoints. A 404 means the academy has no store (catalog)
// or the product id is unknown (product detail).
const PUBLIC_PATH = '/api/public/companies';

export const storeService = {
  async getCatalog(slug: string): Promise<StoreCatalog> {
    const response = await fetch(`${PUBLIC_PATH}/${slug}/store`);
    if (!response.ok) throw new Error('Failed to fetch store catalog');
    return response.json();
  },

  async getProduct(slug: string, productId: string): Promise<StoreProduct> {
    const response = await fetch(`${PUBLIC_PATH}/${slug}/store/products/${productId}`);
    if (!response.ok) throw new Error('Failed to fetch store product');
    return response.json();
  },
};
